export const netConfigData = {
  mainnet: {
    version: "v2.1.0",
    faucetUrl: null,
    apiUrls: [
      "https://rpc.akt.dev/rest",
      "https://api.akashnet.net:443",
      "https://akash-api.polkachu.com:443",
      "https://rest-akash.ecostake.com",
      "https://rest.lavenderfive.com:443/akash",
      "https://akash-api.polkachu.com",
      "https://akash.c29r3.xyz:443/api",
      "https://akash-api.kleomedes.network",
      "https://akash-mainnet-rest.cosmonautstakes.com:443",
      "https://akash-rest.publicnode.com",
      "https://akash-api.validatornode.com",
      "https://lcd.akash.bronbro.io:443"
    ],
    rpcUrls: [
      "https://rpc.akt.dev/rpc",
      "https://rpc.akashnet.net:443",
      "https://akash-rpc.polkachu.com:443",
      "https://akash.c29r3.xyz:443/rpc",
      "https://akash-rpc.europlots.com:443",
      "https://rpc-akash.ecostake.com:443",
      "https://rpc.lavenderfive.com:443/akash",
      "https://akash-rpc.polkachu.com",
      "https://akash.c29r3.xyz:80/rpc",
      "https://akash-rpc.kleomedes.network",
      "https://akash-mainnet-rpc.cosmonautstakes.com:443",
      "https://akash-rpc.publicnode.com:443"
    ]
  },
  "sandbox-2": {
    version: "v2.1.0",
    faucetUrl: "http://faucet.sandbox-2.aksh.pw/",
    apiUrls: ["https://api.sandbox-2.aksh.pw:443"],
    rpcUrls: ["https://rpc.sandbox-2.aksh.pw:443"]
  }
};
